export default __webpack_public_path__ + "static/media/22.6539dc42.jpg";